import PersonalizationActions from './constants';
import { IActionObject } from './types';

export function setPersonalizationComplete(data: boolean): IActionObject {
  return { type: PersonalizationActions.SET_PERSONALIZATION_COMPLETION, data };
}try {
    // @ts-ignore
    setPersonalizationComplete.displayName = "setPersonalizationComplete";
    // @ts-ignore
    setPersonalizationComplete.__docgenInfo = { "description": "", "displayName": "setPersonalizationComplete", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/personalization/actions.tsx#setPersonalizationComplete"] = { docgenInfo: setPersonalizationComplete.__docgenInfo, name: "setPersonalizationComplete", path: "src/store/personalization/actions.tsx#setPersonalizationComplete" };
}
catch (__react_docgen_typescript_loader_error) { }